import { MessageKey } from '../i18n/messages';
import { PriorityLevel } from '../web-api-client';

export const PRIORITY_ORDER: PriorityLevel[] = [
  PriorityLevel.None,
  PriorityLevel.Low,
  PriorityLevel.Medium,
  PriorityLevel.High
];

/** Chỉ giữ KHÓA dịch ở đây; câu chữ thật nằm trong i18n/messages.ts. */
export const PRIORITY_LABEL_KEY: Record<PriorityLevel, MessageKey> = {
  [PriorityLevel.None]: 'priority.none',
  [PriorityLevel.Low]: 'priority.low',
  [PriorityLevel.Medium]: 'priority.medium',
  [PriorityLevel.High]: 'priority.high'
};

export const PRIORITY_TAG_CLASS: Record<PriorityLevel, string> = {
  [PriorityLevel.None]: 'tag tag-idle',
  [PriorityLevel.Low]: 'tag tag-idle',
  [PriorityLevel.Medium]: 'tag tag-info',
  [PriorityLevel.High]: 'tag tag-danger'
};
